module.exports = __webpack_public_path__ + "img-dashboard/register/instagram.589c0509.png";